export default function ReferencesControleConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('references.controle');
}

ReferencesControleConfiguration.$inject = ['$translatePartialLoaderProvider'];
